'use client'

import { useResponsive, useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import HelpToFindContent from './help-to-find-content-internal'
import { ReactNode } from 'react'

type Props = {
  children?: ReactNode
}

export const HelpToFindContentLegacy = ({ children }: Props) => {
  const { translate } = useI18n()
  const { site } = useSiteContext()
  const responsive = useResponsive()

  return (
    <HelpToFindContent site={site} translate={translate} responsive={responsive}>
      {children && children}
    </HelpToFindContent>
  )
}
